import React, {Component} from 'react';
import {observer} from "mobx-react";
import classnames from "classnames";
import PropTypes from "prop-types";

import {ExclamationOctagonFill} from 'react-bootstrap-icons';

import Card from 'react-bootstrap/Card';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Alert from "react-bootstrap/Alert";

import {AppContext, useAppContext} from '@uw-it-sis/lib-react/lib/AppContext';
import SimpleState from "@uw-it-sis/lib-react/lib/SimpleState";

import notifyStore from '@uw-it-sis/lib-react-myplan/lib/NotifyStore';

const NotifyEndPoint = (props) => {
    const appStore = useAppContext().appStore;
    let endpoint = notifyStore.getEndPoint(props.protocol);
    let endpointAddress = "Not Found.";
    let hasEndpointAddress = false;
    let editLink = null;

    if (endpoint) {
        hasEndpointAddress =
            endpoint.hasOwnProperty('EndpointAddress') &&
            endpoint.EndpointAddress !== '' &&
            endpoint.EndpointAddress !== null;

        if (hasEndpointAddress) {
            endpointAddress = endpoint.EndpointAddress;
        }
    } else {
        let notifyUrl = `${appStore.getNotifyUrl()}/notify/#/?edit_contacts=true`
        editLink = <a href={notifyUrl} target="_blank">Edit</a>
    }

    return (
        <>
            <div><strong>{props.title}:</strong></div>
            <div className={classnames({"text-muted": !hasEndpointAddress})}>{endpointAddress} {editLink}</div>
        </>
    );
}

NotifyEndPoint.propTypes = {
    title: PropTypes.string.isRequired,
    protocol: PropTypes.string.isRequired
};

class Notify extends Component {
    constructor(props, context) {
        super(props);
        this.store = notifyStore;
        this.appStore = context.appStore;
    }

    static contextType = AppContext;

    componentDidMount() {
        if ( ! this.appStore.isSocialUser() && ! this.appStore.isAdviser() ) {
            this.store.loadNotifyData();
        }
    }

    buildDoneComponent = () => {
        let notifyInfo;
        // If user has no endpoints, get some extra info.
        if ( !notifyStore.hasEndPoints() ) {
            notifyInfo = <p className="mt-3 mb-0"><a href="https://itconnect.uw.edu/learn/tools/notify-uw/" target="_blank">Learn more about the Notify.UW course notification service</a> and set up your information in <a href={this.appStore.getNotifyUrl()} target="_blank">Notify.UW</a>.</p>;
        }

        return (
            <>
                <p>Manage your contact methods (email vs. SMS/text) and all seat availability notifications in <a href={this.appStore.getNotifyUrl()} target="_blank">Notify.UW</a>. Find <a href="https://itconnect.uw.edu/learn/tools/notify-uw/" target="_blank">helpful tips about Notify.UW</a>.</p>
                <Row className="g-3">
                    <Col xs={12} sm={6} md={4} lg={3}>
                        <NotifyEndPoint title="Email" protocol="email" />
                    </Col>
                    <Col xs={12} sm={6} md={4} lg={3}>
                        <NotifyEndPoint title="SMS / Text" protocol="sms" />
                    </Col>
                </Row>
                {notifyInfo}
            </>
        )
    }

    buildErrorComponent = () => {
        return (
            <Alert variant="danger"
                   className="d-inline-flex align-items-center mb-0 py-2 fs-7"
                   aria-live="polite"
                   aria-atomic={true}>
                <ExclamationOctagonFill aria-hidden={true} className="me-2"/>
                <span>Notify.UW Settings are currently unavailable</span>
            </Alert>
        )
    }

    render() {
        if ( ! this.appStore.isSocialUser() && ! this.appStore.isAdviser() ) {
            return (
                <Card bg="transparent" className="border">
                    <Card.Header>
                        <Card.Title as="h2" className="mb-0">Notify.UW Settings</Card.Title>
                    </Card.Header>
                    <Card.Body>
                        <SimpleState
                            state={this.store.state}
                            doneComponentBuilder={this.buildDoneComponent}
                            errorComponentBuilder={this.buildErrorComponent}
                            name="AccountNotify"
                        />
                    </Card.Body>
                </Card>
            );
        } else {
            return null;
        }
    }
}

export default observer(Notify);